<template>
  <div class="page3-container">
    <Step2Desktop 
      v-if="!isMobile" 
      ref="desktopStep2" 
      @leavebuilder="leaveBuilder" 
      @changepage="changePage" 
      @gostep="goStep" 
    />
    <Step2Mobile 
      v-else 
      ref="mobileStep2" 
      @leavebuilder="leaveBuilder" 
      @changepage="changePage" 
    />
  </div>
</template>

<script>
import Step2Desktop from './Step2Desktop.vue';
import Step2Mobile from './Step2Mobile/Step2Mobile.vue';

export default {
  name: 'Page3',
  
  components: {
    Step2Desktop,
    Step2Mobile
  },
  
  data() {
    return {
      windowWidth: window.innerWidth
    };
  },
  
  computed: {
    isMobile() {
      return this.windowWidth < 768;
    }
  },
  
  methods: {
    changePage(increment) {
      this.$emit("changepage", increment);
    },
    
    leaveBuilder() {
      this.$emit("leavebuilder");
    },
    
    goStep(step) {
      this.$emit("gostep", step);
    },
    
    showSort() {
      const activeComponent = this.isMobile ? this.$refs.mobileStep2 : this.$refs.desktopStep2;
      if (activeComponent && activeComponent.showSort) {
        activeComponent.showSort();
      }
    },
    
    showFilters() {
      const activeComponent = this.isMobile ? this.$refs.mobileStep2 : this.$refs.desktopStep2;
      if (activeComponent && activeComponent.showFilters) {
        activeComponent.showFilters();
      }
    },
    
    handleResize() {
      this.windowWidth = window.innerWidth;
    }
  },
  
  mounted() {
    window.addEventListener('resize', this.handleResize);
  },
  
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  }
};
</script>

<style scoped>
.page3-container {
  width: 100%;
  display: flex;
}

@media screen and (max-width: 768px) {
  .page3-container {
    width: 100%;
    height: fit-content;
  }
}
</style>